import "core-js/modules/es6.array.map";
import _kebabCase from "lodash/kebabCase";
import _isArray from "lodash/isArray";
import _isEmpty from "lodash/isEmpty";
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classes from '@nerdwallet/base-styles/classes';
import { Li, List, Type } from '@nerdwallet/currency';
import { sanitizeNode } from './lib/utils';

var OptionalListContent = function OptionalListContent(_ref) {
  var className = _ref.className,
      content = _ref.content,
      contentLabel = _ref.contentLabel,
      useLiPadding = _ref.useLiPadding;
  var hasOptionalListContent = !_isEmpty(content);
  return /*#__PURE__*/React.createElement(Fragment, null, hasOptionalListContent && /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Type, {
    bold: true
  }, contentLabel), _isArray(content) ? /*#__PURE__*/React.createElement(List, null, content.map(function (listBullet) {
    return /*#__PURE__*/React.createElement(Li, {
      key: "bullet-".concat(_kebabCase(listBullet)),
      className: classes({
        'margin-bottom-2': useLiPadding
      })
    }, sanitizeNode(listBullet));
  })) : sanitizeNode(content)));
};

OptionalListContent.propTypes = {
  className: PropTypes.string,
  content: PropTypes.node,
  contentLabel: PropTypes.string,
  useLiPadding: PropTypes.bool
};
OptionalListContent.defaultProps = {
  useLiPadding: false
};
export default OptionalListContent;